var AT_Slider ={
  
    owlSlider : function(){
      
      	jQuery(".sb-product-deals").length && jQuery(".sb-product-deals").owlCarousel({
			loop 		: false
          	,nav		: true
          	,dots 		: false
      		,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
		});
      
      	jQuery(".sb-testimonials-list").length && jQuery(".sb-testimonials-list").owlCarousel({
			loop 		: false
          	,nav		: true
          	,dots 		: false
      		,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
		});
      
      	jQuery(".product-list").length && jQuery(".product-list").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
            var current = e.relatedTarget.current()
            var items = $(this).find('.owl-stage').children()
            var add = e.type == 'changed' || e.type == 'initialized'

            items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
        }).owlCarousel({
			loop 		: false
          	,nav		: true
          	,dots 		: false
      		,items		: 5
			,responsive : {
              	0:{
                	items: 1
                }
              	,480:{
                	items: 2
                }
                ,768:{
                  items: 3
                }
            	,992:{
              		items: 4
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
		});
      
   jQuery(".home-tab").length && jQuery(".home-tab").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
    var current = e.relatedTarget.current();
    var items = $(this).find('.owl-stage').children();
    var add = e.type == 'changed' || e.type == 'initialized';

    items.eq(e.relatedTarget.normalize(current)).toggleClass('current', add);
}).owlCarousel({
    loop        : true,
    nav         : false,
    dots        : false,
    items       : 6,
    autoplay    : true,
    autoplayTimeout: 4500,
    autoplayHoverPause: true, // Optional: pause on hover
    responsive : {
        0:{
            items: 1
        },
        480:{
            items: 2
        },            	
        992:{
            items: 3
        },
        1200:{
            items: 4
        }
    },
    navText    : ['<span class="button-prev"></span>', '<span class="button-next"></span>']
});

      jQuery(".featured-tab").length && jQuery(".featured-tab").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
                  var current = e.relatedTarget.current()
                  var items = $(this).find('.owl-stage').children()
                  var add = e.type == 'changed' || e.type == 'initialized'
      
                  items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
              }).owlCarousel({
      			loop 		: false
                	,nav		: true
                	,dots 		: false
            		,items		: 6
      			,responsive : {
                    	0:{
                      	items: 1
                      }
                    	,480:{
                      	items: 2
                      }            	
                  	,992:{
                    		items: 5
                  	}
                      ,1200:{
                      	items: 5
                      }
                	}
                	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
      		});
            
      
      


      
      	jQuery(".related-items").length && jQuery(".related-items").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
            var current = e.relatedTarget.current()
            var items = $(this).find('.owl-stage').children()
            var add = e.type == 'changed' || e.type == 'initialized'

            items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
        }).owlCarousel({
			loop 		: false
          	,nav		: true
          	,dots 		: false
      		,items		: 5
			,responsive : {
              	0:{
                	items: 1
                }
              	,480:{
                	items: 2
                }
            	,992:{
              		items: 3
            	}
              	,1200:{
              		items: 4
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
		});

        jQuery("#gallery-image").length && jQuery('#gallery-image').owlCarousel({
            nav			: true
          	,dots 		: false
          	,margin		: 20
          	,mouseDrag	: true
			,responsive : {
                0:{
                	items: 3
                }
              	,480:{
                	items: 4
                }
                ,768:{
                      items: 3
                }
            	,1199:{
              		items: 4
            	}
          	}
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });
      	
      	jQuery(".au-slider").length && jQuery('.au-slider').owlCarousel({
          	nav		: true
          	,dots 		: false
      		,items		: 3
          	,margin		: 30
			,responsive : {
              	0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
              	,980:{
              		items: 3
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

	}
  
  	,init : function(){
      this.owlSlider();
    }
  
}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery.fn.extend({
  scrollToMe: function() {
    if (jQuery(this).length) {
      var top = jQuery(this).offset().top - 250;
      jQuery('html,body').animate({
        scrollTop: top
      }, 500);
    }
  },
});;

jQuery(document).ready(function($) {
	
	AT_Slider.init();
  
    $('.rating-links a').click(function() {
      $('.product-simple-tab ul li').removeClass('active');
      $('#tab_review_tabbed').addClass('active');
      $('.product-simple-tab .tab-content .tab-pane').removeClass('active');
      $('#tab_review').addClass('active');
      $('#tab_review_tabbed').scrollToMe();
      return false;
    });
      
});